<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PublicLayout from '@/Layouts/PublicLayout.vue'
import BrandHero from '@/Components/Public/BrandHero.vue'
import ProductCard from '@/Components/Public/ProductCard.vue'
import EmptyResults from '@/Components/Public/EmptyResults.vue'

defineOptions({ layout: PublicLayout })

const { t } = useI18n()

const props = defineProps({
  slug:       { type: String, required: true },
  seo:        { type: Object, required: true },
  collection: { type: Object, required: true },
  tours:      { type: Array,  default: () => [] },
  base_path:  { type: String, default: '/tours' },
})
const c = props.collection
</script>

<template>
  <Head>
    <title>{{ seo.title }}</title>
    <meta name="description" :content="seo.description">
  </Head>

  <BrandHero kind="tour" :eyebrow="c.hero.eyebrow" :title="c.hero.headline">
    <p class="ec-lede">{{ c.hero.sub }}</p>
  </BrandHero>

  <section class="listing">
    <div class="listing__inner">
      <EmptyResults
        v-if="tours.length === 0"
        :title="t('public.tours.empty_title')"
        :sub="t('public.tours.empty_sub')"
        :clear-href="base_path"
        :clear-label="t('public.tours.back')"
      />

      <ul v-else class="grid">
        <li v-for="tr in tours" :key="tr.id">
          <ProductCard kind="tour" :item="tr" :href="`${base_path}/${tr.id}`" />
        </li>
      </ul>

      <p class="ec-back">
        <a :href="base_path" class="ec-back__link">{{ t('public.tours.back') }} →</a>
      </p>
    </div>
  </section>
</template>

<style scoped>
.ec-lede { margin: 1rem 0 0; font-size: clamp(1.05rem, 2vw, 1.3rem); line-height: 1.5; max-width: 52ch; opacity: 0.92; }

.listing { --card-accent: var(--second); background: var(--bg); }
.listing__inner { max-width: 96rem; margin: 0 auto; padding: clamp(1.75rem, 4vw, 2.75rem) clamp(1.25rem, 4vw, 3rem) 4rem; }

.grid { list-style: none; padding: 0; margin: 0; display: grid; grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr)); gap: 1.25rem; }

.ec-back { margin: 2.5rem 0 0; text-align: center; }
.ec-back__link { color: var(--azure, var(--second)); text-decoration: none; font-weight: 700; }
.ec-back__link:hover { text-decoration: underline; }
</style>
